import ErrorBoundary from 'components/errorBoundary/ErrorBoundary'
import NotFound from 'pages/notFound/NotFound'
import React, { useState } from 'react'
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom'
import Layout from 'components/layout/Layout'
import Upload from 'pages/upload/Upload'
import { DataDomainTypes } from 'pages/evidence/evidence.enums'
import { CompoundFilterProvider } from 'context/CompoundFilterContext'
import StaticPage from 'components/staticPage/StaticPage'
import IfuPage from 'pages/ifu/IfuPage'
import { Routes } from './common/routeConfig'
import Compounds from './pages/compounds/Compounds'
import MolecularBiomarkers from './pages/molecularBiomarker/MolecularBiomarkers'
import Targets from './pages/targets/Targets'
import EvidencePage from './pages/evidence/EvidencePage'

type Props = {}

const App: React.FC<Props> = () => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true)
    const [selectedSubmenu, setSelectedSubmenu] = useState<string>('compounds')

    return (
        <ErrorBoundary>
            <RouterRoutes>
                <Route path="" element={<Upload />} />
                <Route
                    path="/"
                    element={
                        <Layout
                            setIsMenuOpen={setIsMenuOpen}
                            selectedSubmenu={selectedSubmenu}
                            setSelectedSubmenu={setSelectedSubmenu}
                        />
                    }
                >
                    <Route path="ifu" element={<IfuPage />} />

                    <Route
                        path="disclaimer"
                        element={<StaticPage page="disclaimer" withTitle />}
                    />

                    <Route
                        path="targets"
                        element={<Targets isMenuOpen={isMenuOpen} />}
                    />

                    <Route
                        path="targets/:domainItemId"
                        element={
                            <EvidencePage
                                isMenuOpen={isMenuOpen}
                                type={DataDomainTypes.target}
                            />
                        }
                    />

                    <Route
                        path="compounds"
                        element={
                            <CompoundFilterProvider>
                                <Compounds isMenuOpen={isMenuOpen} />
                            </CompoundFilterProvider>
                        }
                    />

                    <Route
                        path="compounds/:domainItemId"
                        element={
                            <EvidencePage
                                isMenuOpen={isMenuOpen}
                                type={DataDomainTypes.compound}
                            />
                        }
                    />

                    <Route
                        path="drivers"
                        element={
                            <MolecularBiomarkers isMenuOpen={isMenuOpen} />
                        }
                    />

                    <Route
                        path="drivers/:domainItemId"
                        element={
                            <EvidencePage
                                isMenuOpen={isMenuOpen}
                                type={DataDomainTypes.molecularBiomarker}
                            />
                        }
                    />

                    <Route
                        element={<Navigate to={Routes.NOT_FOUND} replace />}
                    />

                    <Route path="*" element={<NotFound />} />
                </Route>
            </RouterRoutes>
        </ErrorBoundary>
    )
}

export default App